import { render, staticRenderFns } from "./AppHelpMenu.vue?vue&type=template&id=39895bb4&scoped=true&"
import script from "./AppHelpMenu.vue?vue&type=script&lang=js&"
export * from "./AppHelpMenu.vue?vue&type=script&lang=js&"
import style0 from "./AppHelpMenu.vue?vue&type=style&index=0&id=39895bb4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39895bb4",
  null
  
)

export default component.exports